export const BASE_URL = process.env.NODE_ENV==='development'? "api":"";
export const LOCAL_URL =  `http://116.62.205.126:3003`||"http://localhost:3003";
export const TIME_OUT = 16000;

//export const MOCK_URL = "https://yapi.bestdealer.com/mock/385"
//export const MOCK_URL = "http://localhost:3000/api" //"http://10.118.59.20:8071"
//console.log(11,process.env.NODE_ENV)
//export const BASE_URL = "https://www-pilc.starblink.co/api"
